import React, { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import { Trans } from 'react-i18next';
import SupportFormLink from '@supplierRegistration/components/SupportFormLink';

interface RegistrationFailedMessageProps {
  errorLogId?: string;
}

const RegistrationFailedMessage: FunctionComponent<RegistrationFailedMessageProps> = ({ errorLogId }) => {
  return (
    <div>
      <Trans i18nKey='supplierValidation.supplierRegister.errors.anErrorOccurredDuringTheRegistration'>
        An error occurred during the registration. Please <SupportFormLink>contact us</SupportFormLink> for assistance.
      </Trans>
      {errorLogId && (
        <>
          <br />
          <Trans i18nKey='supplierValidation.supplierRegister.errors.referToErrorCode' values={{ errorLogId }}>
            Refer to error code: <LtrText>{'{{ errorLogId }}'}</LtrText>
          </Trans>
        </>
      )}
    </div>
  );
};

export default RegistrationFailedMessage;

// The error log id is always Latin text that starts with digits. When it is embedded in an RTL
// translation (Hebrew), the bidi algorithm gives its leading digits a different embedding level
// than the rest of the id, and the reordering pass throws them across the surrounding text
// ("69 :קוד השגיאה dcf1d41..."). Isolating the id keeps it a single LTR run in any language.
const LtrText = styled.span`
  direction: ltr;
  unicode-bidi: isolate;
`;
